export const DATE_TIME_FORMAT = "DD-MM-YYYY HH:mm:ss.SSS";
export const DATE_FORMAT = "DD-MM-YYYY";

export const BACKEND_DATE_FORMAT = "YYYY-MM-DD";
